import { SET_HOME_PAGE_QUERY_PARAMS } from "../types/homePageQueryParams";

export const setHomePageQueryParams = (payload) => ({
    type: SET_HOME_PAGE_QUERY_PARAMS,
    payload
})
